// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Eww","buttons":"styles_buttons__2IzOo"};